import React from 'react';

// Custom Logo Component - Black box with 3 white circles
const SabiwabeeLogo = ({ className = "w-5 h-5" }) => (
  <svg 
    viewBox="0 0 24 24" 
    className={className}
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Black box background */}
    <rect x="2" y="2" width="20" height="20" rx="3" fill="black"/>
    
    {/* Three white circles */}
    <circle cx="8" cy="8" r="2" fill="white"/>
    <circle cx="16" cy="8" r="2" fill="white"/>
    <circle cx="12" cy="16" r="2" fill="white"/>
  </svg>
);

export default SabiwabeeLogo; 